(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aronyvo-chair-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
 function boot(){document.querySelectorAll('[data-av16-finder]').forEach(init);}
 function init(root){
  if(root.dataset.ready==='1')return;
  const data=root.querySelector('[data-finder-products]');
  let products;
  try{products=JSON.parse(data.textContent);}catch(_e){return;}
  root.dataset.ready='1';
  const form=root.querySelector('form');
  const result=root.querySelector('[data-results]');
  const cards=root.querySelector('[data-result-cards]');
  const title=root.querySelector('[data-result-title]');
  const text=root.querySelector('[data-result-text]');
  const template=root.querySelector('[data-card-template]');
  const ranges={low:[0,Number(root.dataset.budgetLowMax)],mid:[Number(root.dataset.budgetMidMin),Number(root.dataset.budgetMidMax)],high:[Number(root.dataset.budgetHighMin),Number(root.dataset.budgetHighMax)],top:[Number(root.dataset.budgetTopMin),Number(root.dataset.budgetTopMax)]};
  const documented=s=>Boolean(s)&&!(/non renseign|non document|à confirmer/i.test(s));
  const hasPriority=(p,key)=>key==='mesh'?/maille/i.test(p.materials):key==='arms'?documented(p.arms)&&/réglables?|ajustables?|3D|4D/i.test(p.arms):documented(p.lumbar);
  const score=(p,hours)=>{
   if(hours==='short')return 0;
   let score=0;
   if(/régl|ajust|verrouill/i.test(p.lumbar))score+=hours==='long'?4:2;
   if(/régl|couliss/i.test(p.depth)&&!(/aucun|non confirmé/i.test(p.depth)))score+=hours==='long'?3:1;
   if(documented(p.arms)&&/3D|4D|réglables?/i.test(p.arms))score+=1;
   return score;
  };
  form.addEventListener('submit',event=>{
   event.preventDefault();
   if(!form.reportValidity())return;
   const values={};form.querySelectorAll('input:checked').forEach(input=>values[input.dataset.key]=input.value);
   const range=ranges[values.budget];
   const matched=products.filter(p=>p.available&&p.price>=range[0]&&p.price<=range[1]&&hasPriority(p,values.priority)&&(values.footrest!=='yes'||/^oui/i.test(p.footrest))).sort((a,b)=>score(b,values.hours)-score(a,values.hours)||a.price-b.price).slice(0,3);
   cards.replaceChildren();
   title.textContent=title.dataset[matched.length?'found':'empty'];
   text.textContent=text.dataset[matched.length?'found':'empty'];
   matched.forEach(p=>{
    const node=template.content.cloneNode(true);
    node.querySelector('[data-card-title]').textContent=p.title;
    node.querySelector('[data-card-price]').textContent=p.money;
    node.querySelector('[data-card-reason]').textContent=(values.priority==='mesh'?p.materials:values.priority==='arms'?p.arms:p.lumbar)+(values.footrest==='yes'?' · '+p.footrest:'');
    node.querySelector('[data-card-link]').href=p.url;
    node.querySelector('[data-card-image-link]').href=p.url;
    const img=node.querySelector('[data-card-image]');
    if(p.image){img.src=p.image;img.alt=p.title;}else img.remove();
    cards.appendChild(node);
   });
   result.hidden=false;result.focus();
  });
  form.addEventListener('change',()=>{result.hidden=true;cards.replaceChildren();});
  form.addEventListener('reset',()=>{result.hidden=true;cards.replaceChildren();});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aronyvo-v5-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
function setup(section){
  if(section.dataset.an5Active==="1")return;
  section.dataset.an5Active="1";
  var slides=Array.prototype.slice.call(section.querySelectorAll("[data-an5-slide]"));
  var dots=Array.prototype.slice.call(section.querySelectorAll("[data-an5-dot]"));
  var idx=0;
  function show(n){
    idx=(n+slides.length)%slides.length;
    slides.forEach(function(slide,i){slide.hidden=i!==idx;});
    dots.forEach(function(dot,i){dot.setAttribute("aria-current",i===idx?"true":"false");});
  }
  dots.forEach(function(dot,i){dot.addEventListener("click",function(){show(i);});});
  section.querySelector("[data-an5-prev]").addEventListener("click",function(){show(idx-1);});
  section.querySelector("[data-an5-next]").addEventListener("click",function(){show(idx+1);});
}
function boot(){document.querySelectorAll("[data-an5-hero]").forEach(setup);}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",boot);}else{boot();}
document.addEventListener("shopify:section:load",boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aronyvo-v8-compare"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
 const messages=JSON.parse(root.dataset.av18Messages || "{}");
 if(root.dataset.av8cmpReady==="1")return;root.dataset.av8cmpReady="1";
 var script=root.querySelector("[data-av8cmp-data]");if(!script)return;
 var products;
 try{products=JSON.parse(script.textContent);}catch(_e){return;}
 if(!products.length)return;
 var selects=Array.prototype.slice.call(root.querySelectorAll("[data-av8cmp-select]"));
 var heads=Array.prototype.slice.call(root.querySelectorAll("[data-av8cmp-head]"));
 var warning=root.querySelector("[data-av8cmp-warning]");
 var defaults=[root.dataset.defaultOne,root.dataset.defaultTwo,root.dataset.defaultThree];
 var initial=defaults.map(function(handle,i){var index=products.findIndex(function(p){return p.handle===handle;});return index>=0?index:Math.min(i,products.length-1);});
 try{
  var chairId=new URLSearchParams(window.location.search).get("chaise");
  var preselected=products.findIndex(function(p){return String(p.id)===chairId;});
  if(preselected>=0){
   var remaining=products.map(function(_,i){return i;}).filter(function(i){return i!==preselected;});
   initial=[preselected,remaining[0]??preselected,remaining[1]??remaining[0]??preselected];
  }
 }catch(_e){}
 selects.forEach(function(select,i){select.value=String(products[initial[i]]?.id||"");select.addEventListener("change",render);});
 function render(){
  var chosen=selects.map(function(s){return products.find(function(p){return String(p.id)===s.value})||null;});
  var used=chosen.filter(Boolean).map(function(p){return p.id});
  var duplicates=used.length!==new Set(used).size;
  warning.hidden=!duplicates;
  heads.forEach(function(th,i){
   while(th.firstChild)th.removeChild(th.firstChild);
   var p=chosen[i];if(!p){th.textContent=messages.js_1;return;}
   var panel=document.createElement("div");panel.className="av8cmp__product";
   if(p.image){var img=document.createElement("img");img.src=p.image;img.alt=p.title;img.loading="lazy";panel.appendChild(img);}
   var name=document.createElement("strong");name.textContent=p.title;panel.appendChild(name);
   var price=document.createElement("small");price.textContent=p.price;panel.appendChild(price);
   var link=document.createElement("a");link.href=p.url;link.textContent=messages.js_2;panel.appendChild(link);
   th.appendChild(panel);
  });
  var cells=root.querySelectorAll("[data-av8cmp-value]");
  cells.forEach(function(td){
   var value=td.getAttribute("data-av8cmp-value")||"";
   var ix=value.lastIndexOf("-");var key=value.substring(0,ix);var i=Number(value.substring(ix+1));
   var item=chosen[i];
   td.textContent=item?(item.specs[key]||messages.js_3):"—";
  });
 }
 render();
}
function initAll(){document.querySelectorAll("[data-av8cmp]").forEach(init);}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initAll);else initAll();
document.addEventListener("shopify:section:load",initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
